module.exports = __webpack_public_path__ + "static/media/preview_private_course_A.9ebeb544.png";